export const spaceStateKey = 'space';
export const threadStateKey = 'thread';
export const commentStateKey = 'comment';
export const draftThreadStateKey = 'draft-thread';
